import { Box, Text } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone';
import { FC } from 'react';
import { useServiceFormatter } from '../hooks/useServiceFormatter';
import { Service } from '@common/types';

type AccordionServiceItemProps = {
  service: Service;
  isLastServiceAndCategory: boolean;
  useSmallerBottomPadding: boolean;
};

const AccordionServiceItem: FC<AccordionServiceItemProps> = ({
  service,
  isLastServiceAndCategory,
  useSmallerBottomPadding,
}) => {
  const { t } = useTranslation();
  const { startingPriceFormatter } = useServiceFormatter();

  return (
    <>
      <Box
        dataHook="accordion-service"
        direction="vertical"
        paddingLeft="18px"
        paddingRight="18px"
        paddingTop="15px"
        paddingBottom="15px"
        border="1px solid #DFE5EB"
        borderRadius="8px"
      >
        <Text size="medium" weight="thin" secondary>
          {t(`explore.services.${service.displayKey}`)}
        </Text>
        <Text size="small" weight="thin" light secondary>
          {t(`profile-page-${service.displayKey}-description`)}
        </Text>
        <Box height="12px" />
        <Text size="tiny" weight="thin" secondary>
          {t('profile-page-mobile-starting-rate-price', {
            amount: startingPriceFormatter(service.minPrice),
          })}
        </Text>
      </Box>
      {!isLastServiceAndCategory && (
        <Box height={useSmallerBottomPadding ? '6px' : '12px'} />
      )}
    </>
  );
};

export default AccordionServiceItem;
